export default __webpack_public_path__ + "images/f3a480b4c017458c97383f9930604b17-folk.webp";